// Hash-Routing: URL-Hash <-> {view, topicId, mode, meinTab}.
// parseHash nutzt die Laufzeit-Globals window + ALL_DATA; buildHash ist rein.
export function parseHash() {
  const hash = window.location.hash.slice(1);
  const parts = hash.split("/");
  if (!hash) return { view: "landing", topicId: "luhmann", mode: "entdecken", meinTab: "erkundung" };
  if (parts[0] === "about") return { view: "about", topicId: "luhmann", mode: "entdecken", meinTab: "erkundung" };
  if (parts[0] === "mein") return { view: "mein", topicId: "luhmann", mode: "entdecken", meinTab: "erkundung" };
  if (parts[0] === "thinker" && parts[1] && ALL_DATA[parts[1]]) {
    const m = ["entdecken","vernetzen","anwenden"].includes(parts[2]) ? parts[2] : "entdecken";
    return { view: "thinker", topicId: parts[1], mode: m, meinTab: "erkundung" };
  }
  return { view: "landing", topicId: "luhmann", mode: "entdecken", meinTab: "erkundung" };
}

export function buildHash(view, topicId, mode) {
  if (view === "about") return "#about";
  if (view === "mein") return "#mein";
  if (view === "thinker") return "#thinker/" + topicId + (mode && mode !== "entdecken" ? "/" + mode : "");
  return "#";
}
